import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import questions from "../questiondatas/questions";
import axios from "axios";
import "./resultpage.css";
import Modal from './ModalBox'; 

const ResultsPage = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { responses,startTime } = location.state || {};
  const email = location.state?.email || localStorage.getItem("email");
  const username = localStorage.getItem("username");
  const logoSrc = "./UNextLogo2.png";
  const [selectedCount, setSelectedCount] = useState(0);
  const [selectedCheckboxes, setSelectedCheckboxes] = useState({});
  const [isLoadingPDF, setIsLoadingPDF] = useState(false);
  const [groupedQuestions, setGroupedQuestions] = useState(() => {
    if (!responses.length) {
      console.error("Responses are missing or invalid.");
      return {};
    }
    return questions.reduce((acc, question, index) => {
      const { category } = question;
      if (!acc[category]) {
        acc[category] = [];
      }
      acc[category].push({
        questionNumber: question.id,
        score: responses[index],
        additionalScore: 0,
      });
      return acc;
    }, {});
  });
  const [isSummarySubmitted, setIsSummarySubmitted] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [modalProps, setModalProps] = useState({});
  const [timeLeft, setTimeLeft] = useState(() => {
    const storedStartTime = startTime || sessionStorage.getItem("startTime");
    const currentTime = Date.now();

    if (storedStartTime) {
      const elapsed = Math.floor((currentTime - parseInt(storedStartTime, 10)) / 1000);
      return Math.max(1200 - elapsed, 0); // Remaining time
    }

     // If no valid `startTime`, log out the user
     //alert("Session expired. Redirecting to login.");
     showModalBox("Session expired. Redirecting to login.", () => navigate("/logout"), true);
     navigate("/logout");
     return 0;
   });

      
        
     useEffect(() => {
      if (timeLeft <= 0) {
       /* alert("Your time has expired. You will be logged out.");
        sessionStorage.clear(); // Clear all session data
        navigate("/logout");
        */
        showModalBox("Your time has expired. You will be logged out.", () => {
          sessionStorage.clear();
          navigate("/logout");
        }, true);
        return;
      }
      const interval = setInterval(() => {
        setTimeLeft((prevTime) => Math.max(prevTime - 1, 0));
      }, 1000);
      return () => clearInterval(interval); // Cleanup interval on unmount
    }, [timeLeft, navigate]);

  
    const showModalBox = (message, onConfirm, hideCancelButton = false) => {
      setModalProps({ message, onConfirm, hideCancelButton });
      setShowModal(true);
    };


  const formatTime = (seconds) => {
    const minutes = Math.floor(seconds / 60);
    const secs = seconds % 60;
    

    return (
      <span>
        <span style={{ color: "green" }}>{minutes.toString().padStart(2, "0")}</span>
        <span style={{ color: "orange" }}>:{secs.toString().padStart(2, "0")}</span>
      </span>
    );

  };
  

  const handleSummarySubmit = () => {
    if (selectedCount < 3) {
      //alert("Please select exactly 3 questions before proceeding.");
      showModalBox(
        "Please select exactly 3 questions before proceeding.",
        () => setShowModal(false),
        true
      );
      
      return;
    }
    //setShowModal(true); // Show modal for confirmation
    showModalBox(
      "Are you sure you want to submit your responses?",
      submitData, // Function to handle data submission
      false // Show the cancel button
    );
  };



  const submitData = async () => {
    const resultData = [];
    Object.keys(groupedQuestions).forEach((category) => {
      groupedQuestions[category].forEach((question) => {
        const { score, additionalScore, questionNumber } = question;
        const grandTotal = score + additionalScore;
        resultData.push({
          email,
          timestamp: new Date().toISOString().slice(0, 19).replace("T", " "),
          questionNumber,
          category,
          rating: score,
          additionalMarks: additionalScore,
          grandTotal,
        });
      });
    });

    try {
      await axios.post("/api/submit-responses", resultData, {
        headers: {
          "Content-Type": "application/json",
        },
      });
      navigate("/logout", { replace: true });
    } catch (error) {
      //alert("Error submitting responses:");
      showModalBox("Error submitting responses:", () => setShowModal(false), true);
      console.error("Error submitting responses:", error);
    }
  };

  const handleViewResults = async () => {
    setIsLoadingPDF(true); // Start loading
    try {
      const response = await axios.get(`/api/download-pdf?email=${encodeURIComponent(email)}`, { responseType: "blob" });
      const pdfBlob = response.data;
      const pdfUrl = URL.createObjectURL(pdfBlob);

      // Create a temporary download link and trigger the download
      const link = document.createElement("a");
      link.href = pdfUrl;
      link.download = "survey-results.pdf"; // Name of the downloaded file
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      navigate("/logout", { replace: true });
    } catch (error) {
      console.error("Error generating PDF:", error);
    } finally {
      setIsLoadingPDF(false); // End loading
    }
  };

  const handleCheckboxChange = (event, index) => {
    const isChecked = event.target.checked;
    const newSelectedCheckboxes = { ...selectedCheckboxes };

    if (isChecked && selectedCount < 3) {
      newSelectedCheckboxes[index] = true;
      setSelectedCount(selectedCount + 1);
    } else if (!isChecked) {
      newSelectedCheckboxes[index] = false;
      setSelectedCount(selectedCount - 1);
    }

    setSelectedCheckboxes(newSelectedCheckboxes);

    const updatedGroupedQuestions = { ...groupedQuestions };
    questions.forEach((question, qIndex) => {
      const categoryQuestions = updatedGroupedQuestions[question.category];
      const questionInGroup = categoryQuestions.find(
        (q) => q.questionNumber === question.id
      );

      if (questionInGroup) {
        questionInGroup.additionalScore = newSelectedCheckboxes[qIndex] ? 4 : 0;
      }
    });

    setGroupedQuestions(updatedGroupedQuestions);
  };

  return (
    <div className="results-page-wrapper">
      <div className="instructions-box">
        <h4>Instructions</h4>
        <p>
          At this point, look over the questions that you rated highest and check 3 questions that seem most true for you. After doing this, you can complete your submission.
        </p>
      </div>

      <div className="results-page">
        <h4>Career Inventory Survey</h4>
        <div className="logo-container">
        <img src={logoSrc} alt="Logo" className="logo" />
      </div>
        <div className="top-left-content">
           <p>Welcome, {username}</p>
        </div>

        <table>
          <thead>
            <tr>
              <th className="center">#</th>
              <th>Question</th>
              <th>Score</th>
              <th>Select(3)</th>
            </tr>
          </thead>
          <tbody>
            {questions
              .map((question, index) => ({
                question,
                score: responses[index],
                index,
              }))
              .sort((a, b) => b.score - a.score)
              .map(({ question, score, index }) => (
                <tr key={index}>
                  <td className="center">{index + 1}</td>
                  <td>{question.text}</td>
                  <td className="center">{score}</td>
                  <td className="center">
                    <input
                      type="checkbox"
                      checked={selectedCheckboxes[index] || false}
                      onChange={(e) => handleCheckboxChange(e, index)}
                      disabled={!selectedCheckboxes[index] && selectedCount >= 3}
                    />
                  </td>
                </tr>
              ))}
          </tbody>
        </table>

        <div className="button-container" style={{ display: "flex", gap: "10px" }}>
          <button
            className="results-page-button"
            onClick={handleSummarySubmit}
            style={{ marginTop: "20px", padding: "10px 20px" }}
            disabled={isSummarySubmitted}
          >
            {isSummarySubmitted ? "Submission Completed" : "End Submission"}
          </button>
          {showModal && (
            <Modal
              message={modalProps.message}
              onConfirm={modalProps.onConfirm}
              onCancel={() => setShowModal(false)}
              hideCancelButton={modalProps.hideCancelButton}
            />
          )}
     
     
     
     

          <button
            onClick={handleViewResults}
            style={{ marginTop: "20px", padding: "10px 20px" }}
            disabled={!isSummarySubmitted || isLoadingPDF}
          >
            {isLoadingPDF ? "Generating PDF..." : "View Results"}
          </button>
        </div>
      </div>

      <div className="timer1">
        {formatTime(timeLeft)}
      </div>

      <div className="footerresult">
      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;© {new Date().getFullYear()} UNext Learning Pvt Ltd
      </div>
    </div>
   
    
  );
};

export default ResultsPage;
